import React from 'react';
import { StyleSheet } from 'react-native';
import { useStyle } from 'react-native-style-utilities';
import { FadeView, theme } from '@sg/garnish';

import {
  LOCATION_RESULTS_BORDER_RADIUS,
  LOCATION_RESULTS_COLLAPSED_HEIGHT_MULTIPLE_RESULTS,
  LOCATION_RESULTS_COLLAPSED_HEIGHT_SINGLE_RESULT,
  LOCATION_RESULTS_THEME_BG_COLOR,
} from '../../LocationResultsV2.constants';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * We utilize a separate `Animated.View` component with custom styles to add a shadow
 * effect because we can't apply it directly, since Locations Results container is
 * modified by `translateY` transform property to expand/collapse.
 */
export const LocationResultsBottomShadow = (
  props: LocationResultsShadowViewProps,
) => {
  const { hasMultipleResults } = props;

  const shadowHeight = hasMultipleResults
    ? LOCATION_RESULTS_COLLAPSED_HEIGHT_MULTIPLE_RESULTS
    : LOCATION_RESULTS_COLLAPSED_HEIGHT_SINGLE_RESULT;

  const shadowDynamicStyle = useStyle(
    () => ({ height: shadowHeight }),
    [shadowHeight],
  );
  const shadowStyles = [styles.shadow, shadowDynamicStyle];

  return (
    <FadeView
      show
      duration={2000}
      style={shadowStyles}
      needsOffscreenAlphaCompositing
      pointerEvents="none"
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  shadow: {
    ...StyleSheet.absoluteFillObject,
    top: 'auto',
    borderRadius: LOCATION_RESULTS_BORDER_RADIUS,
    margin: theme.spacing.medium,

    // NOTE: `backgroundColor` is required to apply elevation on native platforms
    backgroundColor: LOCATION_RESULTS_THEME_BG_COLOR,
    ...theme.elevations['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LocationResultsShadowViewProps = {
  readonly hasMultipleResults: boolean;
};
